import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar';
import Home from './components/home';
import Services from './components/services';
import Contact from './components/contact'; // ✅
import References from './components/references';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} /> {/* ✅ */}
        <Route path="/references" element={<References />} />
      </Routes>
    </Router>
  );
}
export default App